<template>
    <div>
        <div class="ta2-card" id="preview-page">
            <div class="ta2-header">
                <img
                    src="https://d2u1upwdbw709w.cloudfront.net/documents/EXTERNAL%20DOCUMENTS/EVENT_WEBSITE/era-real-estate-logo-light.png"
                    alt="ERA Real Estate"
                    class="ta2-logo"
                />
                <div class="ta2-header-text">
                    <div class="ta2-company-name">ERA REALTY<br/>NETWORK PTE LTD</div>
                    <div class="ta2-licence-label">Estate Agent Licence No.</div>
                    <div class="ta2-licence-no">L3002382K</div>
                </div>
            </div>

            <div class="ta2-photo-wrapper">
                <img :src="coporate_photo" alt="Agent Photo" class="ta2-photo" />
            </div>

            <div class="ta2-name-section">
                <div class="ta2-name">{{ removeSpecialCharNricName(nric_name) }}</div>
                <div class="ta2-name-alt">{{ removeInitialBusinessName(business_name) }}</div>
            </div>

            <div class="ta2-cea-section">
                <span class="ta2-cea-label">CEA Registration No.</span>
                <span class="ta2-cea-no">{{ cea_regno }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { removeSpecialCharNricName, removeInitialBusinessName } from '@/helpers/idtag/filterName';

export default {
    props: ['business_name', 'nric_name', 'coporate_photo', 'cea_regno'],

    setup() {
        return { removeSpecialCharNricName, removeInitialBusinessName };
    },
    methods: {}
}
</script>

<style>
@font-face {
    font-family: 'Red Hat Display';
    src: url('~@/assets/fonts/RedHatDisplay-VariableFont_wght.ttf') format('truetype');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Myriad Pro';
    src: url('~@/assets/fonts/MyriadPro-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Myriad Variable Concept';
    src: url('~@/assets/fonts/MyriadVariableConcept-Roman.otf') format('opentype');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
}

.ta2-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    width: 406px;
    height: 678px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: auto;
}

.ta2-header {
    display: flex;
    align-items: flex-end;
    background: #E31937;
    border-radius: 16px 16px 0 0;
    padding: 35px 20px 25px 20px;
    gap: 24px;
    flex-shrink: 0;
}

.ta2-logo {
    width: 90px;
    height: auto;
    object-fit: contain;
}

.ta2-header-text {
    color: #fff;
    line-height: 1.15;
}

.ta2-company-name {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 600;
    font-size: 22px;
    line-height: 1.15;
}

.ta2-licence-label {
    font-family: 'Myriad Pro', 'Myriad Variable Concept', sans-serif;
    font-weight: 400;
    font-size: 17px;
    margin-top: 4px;
}

.ta2-licence-no {
    font-family: 'Myriad Pro', 'Myriad Variable Concept', sans-serif;
    font-weight: 700;
    font-size: 18px;
}

.ta2-photo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 60px 28px 1px;
}

.ta2-photo {
    width: 200px;
}

.ta2-name-section {
    text-align: center;
    padding: 8px 24px 2px;
    flex-shrink: 0;
}

.ta2-name {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 22px;
    color: #1E2A5E;
    line-height: 1.2;
}

.ta2-name-alt {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 22px;
    color: #1E2A5E;
    line-height: 1.2;
}

.ta2-cea-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 30px 24px 24px;
    flex-shrink: 0;
}

.ta2-cea-label {
    font-family: 'Myriad Pro', 'Myriad Variable Concept', sans-serif;
    font-weight: 400;
    font-size: 19px;
    line-height: 22px;
    color: #1E2A5E;
}

.ta2-cea-no {
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    font-size: 22px;
    line-height: 22px;
    color: #1E2A5E;
}
</style>
